import React from "react"

import ToggleButton from "@material-ui/lab/ToggleButton"

interface Props {
	onChange: () => void
	runner: boolean
}

export const Base = ({ onChange, runner }: Props) => {
	return (
		<ToggleButton
			size="medium"
			className="pt-runners-base"
			value="check"
			selected={runner}
			onChange={onChange}>
			<></>
		</ToggleButton>
	)
}
